(function(){
  var root=document.getElementById('sb-shop');
  if(!root)return;
  var cards=[].slice.call(root.querySelectorAll('.sb-pcard'));
  var filters=[].slice.call(root.querySelectorAll('.sb-filter'));
  var countEl=document.getElementById('sb-count');
  var emptyEl=document.getElementById('sb-empty');
  var clearWrap=document.getElementById('sb-clear-wrap');
  var made='', type='';

  function apply(){
    var shown=0;
    cards.forEach(function(c){
      var okMade=!made||c.getAttribute('data-made')===made;
      var okType=!type||c.getAttribute('data-type')===type;
      var vis=okMade&&okType;
      c.className=vis?c.className.replace(/ ?is-hidden/,''):(c.className.indexOf('is-hidden')>-1?c.className:c.className+' is-hidden');
      if(vis)shown++;
    });
    filters.forEach(function(f){
      var fm=f.getAttribute('data-made'), ft=f.getAttribute('data-type');
      var on=(fm&&fm===made)||(ft&&ft===type);
      f.className=on?(f.className.indexOf('is-active')>-1?f.className:f.className+' is-active'):f.className.replace(/ ?is-active/,'');
    });
    if(emptyEl)emptyEl.hidden=shown>0;
    if(clearWrap)clearWrap.hidden=!(made||type);
    if(countEl){
      var noun=cards.length===1?' product':' products';
      countEl.textContent=(made||type)?shown+' of '+cards.length+noun:cards.length+noun;
    }
    var h='';
    if(type)h='#type-'+type; else if(made)h='#made-'+made;
    if(history.replaceState)history.replaceState(null,'',location.pathname+h);
  }

  filters.forEach(function(f){
    f.addEventListener('click',function(e){
      e.preventDefault();
      var fm=f.getAttribute('data-made'), ft=f.getAttribute('data-type');
      if(fm)made=(made===fm)?'':fm;
      if(ft)type=(type===ft)?'':ft;
      apply();
    });
  });

  function clear(e){if(e)e.preventDefault();made='';type='';apply();}
  var c1=document.getElementById('sb-clear'); if(c1)c1.addEventListener('click',clear);
  var c2=document.getElementById('sb-empty-clear'); if(c2)c2.addEventListener('click',clear);

  var h=location.hash;
  if(h.indexOf('#type-')===0)type=h.slice(6);
  else if(h.indexOf('#made-')===0)made=h.slice(6);
  apply();
})();
